import { AUTH_HEADERS } from '@libs/core';
import type { CreateExchangeTokenResponse } from '@libs/common-types';
import { client } from '../../client';
import { IDENTITY_ENDPOINTS } from '../../constants';
import { getAccessToken } from '@libs/api-proxy-client/utils';

export async function createExchangeToken() {
    const accessToken = getAccessToken();

    return await client.identity<CreateExchangeTokenResponse>(IDENTITY_ENDPOINTS.createExchangeToken, {
        method: 'GET',
        headers: {
            [AUTH_HEADERS.AUTHORIZATION]: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    });
}
